import { tagsList } from "constants/tags";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

export const addTag = async (bodyData) => {
  try {
    const res = await api.add_tag(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const getTagList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_tag_list(pageNum, filters);
    dispatch({ type: tagsList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: tagsList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};

export const getTagById = async (id) => {
  try {
    const res = await api.get_tag_by_id(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateTagById = async (id, bodyData) => {
  try {
    const res = await api.update_tag_by_id(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};